import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllStatuses } from "../../../apis";
import { STATUSES } from "../../configs";

export const fetchAllStatuses = createAsyncThunk(
  STATUSES,
  async (data, thunkAPI) => {
    try {
      const res = await getAllStatuses();
      if (res.status === 200) {
        return res.data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
